import {
    COMICS_CHAPTER_READING_PROGRESS,
    COMICS_TUTORIAL_CLOSE,
} from '../actions/comics';
import {
    USER_LOGIN,
    USER_LOGOUT,
    SELECT_AVATAR,
    RECENTLY_PLAYED_GAME,
    CNPUSH_ENABLED,
    HIDE_BADGGE,
} from '../actions/user';

const initialState = {
    token: undefined,
    avatar: undefined,
    recentlyPlayedGames: [], //ids of recently played games
    pushEnabled: undefined,
    hideBadge: undefined, //hide menu badge from burger menu
};

export default (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGIN:
            return {
                ...state,
                ...action.payload,
                avatar: state.avatar,
            };

        case USER_LOGOUT:
            return {...state, token: undefined};

        case SELECT_AVATAR:
            return {
                ...state,
                avatar: action.payload.avatarIndex,
            };

        case RECENTLY_PLAYED_GAME: {
            //check if current game already exists, and remove it
            let games = state.recentlyPlayedGames || [];
            let recentlyPlayed = games.filter(
                gameId => gameId !== action.gameId,
            );
            return {
                ...state,
                recentlyPlayedGames: [
                    action.gameId,
                    ...recentlyPlayed.slice(0, 2),
                ],
            };
        }
        case COMICS_CHAPTER_READING_PROGRESS: {
            let progress = state.chapterProgress || {};
            let readChapters = state.readChapters || [];

            if (
                action.progress >= 1 &&
                !readChapters.includes(action.chapterId)
            ) {
                readChapters.push(action.chapterId);
            }

            return {
                ...state,
                chapterProgress: {
                    ...progress,
                    [action.chapterId]: {
                        progress: action.progress,
                        date: Date.now(),
                    },
                },
                readChapters,
                comicsTutorialShown:
                    action.progress > 0 ? true : state.comicsTutorialShown,
            };
        }
        case COMICS_TUTORIAL_CLOSE:
            return {
                ...state,
                comicsTutorialShown: true,
            };
        case CNPUSH_ENABLED:
            return {
                ...state,
                pushEnabled: action.enabled,
            };
        case HIDE_BADGGE:
            return {
                ...state,
                hideBadge: true,
            };

        default:
            return state;
    }
};
